import { useCallback } from 'react';
import { AiChatPanelContext } from '@/contexts/AiChatPanelContext/AiChatPanelContext';

export const useAiChatPanel = () => {
    const actorRef = AiChatPanelContext.useActorRef();
    const isOpen = AiChatPanelContext.useSelector(state => state.matches('open'));
    const historySidebarOpen = AiChatPanelContext.useSelector(state => state.matches({ open: 'sidebarHistory' }));

    const open = useCallback(() => actorRef.send({ type: 'OPEN' }), [actorRef]);
    const close = useCallback(() => actorRef.send({ type: 'CLOSE' }), [actorRef]);
    const setIsOpen = useCallback((value: boolean) => {
        actorRef.send({ type: value ? 'OPEN' : 'CLOSE' });
    }, [actorRef]);
    const toggleHistorySidebar = useCallback(() => actorRef.send({ type: 'TOGGLE_HISTORY_SIDEBAR' }), [actorRef]);
    const closeSidebar = useCallback(() => actorRef.send({ type: 'CLOSE_SIDEBAR' }), [actorRef]);

    return {
        isOpen,
        historySidebarOpen,
        open,
        close,
        setIsOpen,
        toggleHistorySidebar,
        closeSidebar,
    };
};
